import { render } from "./AufgabenModalComponent.vue?vue&type=template&id=0b49c032"
import script from "./AufgabenModalComponent.vue?vue&type=script&lang=js"
export * from "./AufgabenModalComponent.vue?vue&type=script&lang=js"

import "./AufgabenModalComponent.vue?vue&type=style&index=0&id=0b49c032&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__